module.exports = __webpack_public_path__ + "img/数据治理_02.f43d8549.svg";